var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotif05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 31.9907,
    height: 16,
    viewBox: "0 0 31.9907 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.9953 0C24.8292 3.86142e-07 31.9907 7.16344 31.9907 16L15.9953 16L15.9953 0Z",
    fill: "#D4623A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M-1.13016e-07 16C2.73242e-07 7.16344 7.16144 3.13036e-07 15.9953 6.99178e-07L15.9953 16L-1.13016e-07 16Z",
    fill: "#E0D65F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.8322 16C7.8322 11.4903 11.4869 7.83448 15.9953 7.83448L15.9953 16L7.8322 16Z",
    fill: "#274766"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotif05);
export default __webpack_public_path__ + "static/media/motif-05.a86c9dad2abb02f5bc5470f3cd3ace99.svg";
export { ForwardRef as ReactComponent };